import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface Brand {
  name: string;
  logo: string;
}

interface BrandFilterProps {
  onBrandSelect?: (brand: string) => void;
  compact?: boolean;
}

export function BrandFilter({ onBrandSelect, compact = false }: BrandFilterProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentBrand = searchParams.get('brand');

  const brands: Brand[] = [
    /*{ name: 'Affinity', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272159/Affinity-icon_wvqalu.png' },*/
    { name: 'Antics', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272159/Antics-icon_obr6sz.png' },
    { name: 'Aztek', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272159/Aztek-icon_uzujr2.png' },
    { name: 'blunt', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272159/blunt-icon_knnxex.png' },
    /*{ name: 'Chubby', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272160/Chubby-icon_yxtxnh.png' },*/
    /*{ name: 'ethic', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272164/ethic-icon_tglute.png' },*/
    /*{ name: 'fasen', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272164/fasen-icon_huxarz.png' },*/
    { name: 'Fuzion', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272159/Fuzion-icon_bwpkr8.png' },
    /*{ name: 'Indo', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272167/Indo-icon_ypq1zm.png' },*/
    { name: 'North', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272165/North-icon_mpjme2.png' },
    { name: 'Striker', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272166/Striker-icon_hwsamx.png' },
    { name: 'CORE', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272161/Core-icon_r6c0g3.webp' },
    /*{ name: 'Revolution', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272166/Revolution-icon_zzdui9.png' },*/
    /*{ name: 'Paradox', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272165/Paradox-icon_gkhzeq.png' },*/
    { name: 'prime', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272165/prime-icon_ek8tu5.png' },
    { name: 'prey', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272165/prey-icon_krdcsu.png' },
    { name: 'drone', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272162/drone-logo_qnoga0.png' },
    { name: 'Lucky', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272164/Lucky-icon_mx5jdu.png' },
    { name: 'Root Industries', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272166/root-industries-icon_c5anmy.webp' },
    { name: 'Tilt', logo: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751272166/Tilt-icon_hrwwo4.png' },
  ];

  const handleBrandClick = (brand: string) => {
    if (onBrandSelect) {
      onBrandSelect(brand);
    } else {
      if (currentBrand?.toLowerCase() === brand.toLowerCase()) {
        navigate('/toukeratas');
      } else {
        navigate(`/toukeratas/brandid/${brand.toLowerCase()}`);
      }
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-6">
      {brands.map((brand) => (
        <div
          key={brand.name}
          onClick={() => handleBrandClick(brand.name)}
          className="bg-white rounded-lg p-1 cursor-pointer transition-all duration-300 hover:shadow-lg hover:scale-105"
        >
          <div className={`flex items-center justify-center ${compact ? 'h-36' : 'h-32'}`}>
            <img
              src={brand.logo}
              alt={brand.name}
              title={brand.name}
              className="w-full h-full object-contain transition-opacity duration-300 hover:opacity-80 invert"
              style={{ filter: 'brightness(0)' }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
